var _defs, _path, _rect, _path2, _ellipse, _ellipse2, _path3, _path4, _path5, _path6, _path7, _mask, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.56536422,102.363636 L168.092188,6.79668011 C184.416168,-2.62797432 205.289561,2.96503439 214.714215,19.2890147 L262.677371,102.363636 L2.56536422,102.363636 Z",
    id: "path-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 219.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500,563 C776.142375,563 1000,535.959391 1000,515.230303 C1000,494.501215 776.142375,477.69697 500,477.69697 C223.857625,477.69697 0,494.501215 0,515.230303 C0,535.959391 223.857625,563 500,563 Z",
    id: "Oval-4",
    fill: "#D9E4FE",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#6995FE",
    x: 242.320819,
    y: 102.363636,
    width: 511.945392,
    height: 409.454545,
    rx: 34.1296928
  })), /*#__PURE__*/React.createElement("path", {
    d: "M559.710001,249.084848 L747.440273,249.084848 L747.440273,385.569697 L559.710001,385.569697 C522.020751,385.569697 491.467577,355.016523 491.467577,317.327273 L491.467577,317.327273 C491.467577,279.638023 522.020751,249.084848 559.710001,249.084848 Z",
    id: "Combined-Shape",
    fill: "#B4CAFE",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.600000024
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M566.53594,238.848485 L754.266212,238.848485 L754.266212,375.333333 L566.53594,375.333333 C528.846689,375.333333 498.293515,344.780159 498.293515,307.090909 L498.293515,307.090909 C498.293515,269.401659 528.846689,238.848485 566.53594,238.848485 Z",
    id: "Combined-Shape",
    fill: "#B4CAFE"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5283E9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    cx: 563.139932,
    cy: 310.50303,
    rx: 37.5426621,
    ry: 37.5333333
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#5283E9",
    cx: 566.552901,
    cy: 307.090909,
    rx: 37.5426621,
    ry: 37.5333333
  })), /*#__PURE__*/React.createElement("path", {
    d: "M602.863259,511.818182 C586.650292,493.708127 576.791809,469.792942 576.791809,443.575758 C576.791809,387.041882 622.632961,341.212121 679.180887,341.212121 C735.728814,341.212121 781.569966,387.041882 781.569966,443.575758 C781.569966,469.792942 771.711482,493.708127 755.498516,511.818182 L602.863259,511.818182 Z",
    id: "Combined-Shape",
    fill: "#5283E9",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-18",
    fill: "#5283E9",
    cx: 689.419795,
    cy: 436.751515,
    rx: 102.389078,
    ry: 102.363636
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682.463003,474.156914 C680.802295,474.53731 678.988663,474.080713 677.695073,472.787122 L641.259166,436.351216 C639.259895,434.351945 639.259895,431.110486 641.259166,429.111215 L644.362024,426.008357 C646.361295,424.009086 649.602754,424.009086 651.602025,426.008357 L681.344207,455.750539 L733.874327,403.220418 C735.873598,401.221147 739.115057,401.221147 741.114328,403.220418 L744.217186,406.323276 C746.216457,408.322547 746.216457,411.564006 744.217186,413.563277 L685.00989,472.770573 C684.28481,473.495653 683.396344,473.957767 682.463003,474.156914 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M750.853242,71.6545455 C733.888864,71.6545455 720.136519,57.9056171 720.136519,40.9454545 C720.136519,23.985292 733.888864,10.2363636 750.853242,10.2363636 C767.81762,10.2363636 781.569966,23.985292 781.569966,40.9454545 C781.569966,57.9056171 767.81762,71.6545455 750.853242,71.6545455 Z M750.853242,64.830303 C764.047759,64.830303 774.744027,54.1366921 774.744027,40.9454545 C774.744027,27.754217 764.047759,17.0606061 750.853242,17.0606061 C737.658726,17.0606061 726.962457,27.754217 726.962457,40.9454545 C726.962457,54.1366921 737.658726,64.830303 750.853242,64.830303 Z",
    id: "Oval-19",
    fill: "#5283E9",
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.887372,416.278788 C167.692856,416.278788 156.996587,405.585177 156.996587,392.393939 C156.996587,379.202702 167.692856,368.509091 180.887372,368.509091 C194.081888,368.509091 204.778157,379.202702 204.778157,392.393939 C204.778157,405.585177 194.081888,416.278788 180.887372,416.278788 Z M180.887372,409.454545 C190.312026,409.454545 197.952218,401.816252 197.952218,392.393939 C197.952218,382.971627 190.312026,375.333333 180.887372,375.333333 C171.462718,375.333333 163.822526,382.971627 163.822526,392.393939 C163.822526,401.816252 171.462718,409.454545 180.887372,409.454545 Z",
    id: "Oval-19-Copy",
    fill: "#5283E9",
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M203.021438,37.7758253 L212.675972,28.1212911 C214.008489,26.7887749 216.168924,26.7887749 217.50144,28.1212911 C218.833957,29.4538073 218.833957,31.6142429 217.50144,32.9467592 L207.846906,42.6012934 L217.50144,52.2558277 C218.833957,53.5883439 218.833957,55.7487795 217.50144,57.0812958 C216.168924,58.413812 214.008489,58.413812 212.675972,57.0812958 L203.021438,47.4267615 L193.366904,57.0812958 C192.034388,58.413812 189.873952,58.413812 188.541436,57.0812958 C187.20892,55.7487795 187.20892,53.5883439 188.541436,52.2558277 L198.19597,42.6012934 L188.541436,32.9467592 C187.20892,31.6142429 187.20892,29.4538073 188.541436,28.1212911 C189.873952,26.7887749 192.034388,26.7887749 193.366904,28.1212911 L203.021438,37.7758253 Z",
    id: "Combined-Shape",
    fill: "#5283E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M817.355909,488.175825 L827.010443,478.521291 C828.34296,477.188775 830.503395,477.188775 831.835911,478.521291 C833.168428,479.853807 833.168428,482.014243 831.835911,483.346759 L822.181377,493.001293 L831.835911,502.655828 C833.168428,503.988344 833.168428,506.14878 831.835911,507.481296 C830.503395,508.813812 828.34296,508.813812 827.010443,507.481296 L817.355909,497.826762 L807.701375,507.481296 C806.368859,508.813812 804.208423,508.813812 802.875907,507.481296 C801.543391,506.14878 801.543391,503.988344 802.875907,502.655828 L812.530441,493.001293 L802.875907,483.346759 C801.543391,482.014243 801.543391,479.853807 802.875907,478.521291 C804.208423,477.188775 806.368859,477.188775 807.701375,478.521291 L817.355909,488.175825 Z",
    id: "Combined-Shape",
    fill: "#5283E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-26",
    transform: "translate(382.252560, 0.000000)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#B4CAFE",
    opacity: 0.5,
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#6995FE",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    mask: "url(#mask-2)",
    x: 0,
    y: 92.1272727,
    width: 273.037543,
    height: 40.9454545
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.3be20f0bc6b06dc157c04a39d2126da2.svg";
export { ForwardRef as ReactComponent };